import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = {
  class: "news-list-wrapper"
};
const _hoisted_2 = {
  class: "news-list-page"
};
const _hoisted_3 = {
  class: "section"
};
const _hoisted_4 = {
  key: 0,
  class: "loading"
};
const _hoisted_5 = {
  key: 1,
  class: "news-list"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "news-content"
};
const _hoisted_8 = {
  class: "news-title"
};
const _hoisted_9 = {
  class: "news-date"
};
const _hoisted_10 = {
  class: "pagination"
};
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { getArticlesByCategory } from '@/api/news';
import SectionTitle from '@/components/SectionTitle.vue';
import Footer from '@/components/Footer.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'NewsList',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const currentPage = ref(1);
    const pageSize = ref(20);
    const total = ref(0);
    const newsList = ref([]);
    const loading = ref(false);
    const categoryTitle = ref('');
    // 分类ID映射
    const categoryMap = {
      10: '通知公告',
      11: '科技新闻',
      12: '院内活动',
      13: '园区动态',
      14: '投融资服务',
      15: '技术转移',
      16: '科研动态',
      17: '中试中心',
      18: '检验检测',
      19: '创新成果',
      20: '行业动态'
    };
    // 获取新闻列表
    const getNewsList = async () => {
      loading.value = true;
      try {
        const categoryId = route.query.categoryId;
        const res = await getArticlesByCategory({
          categoryId: Number(categoryId),
          pageNum: currentPage.value,
          pageSize: pageSize.value
        });
        // console.log('接口返回数据：', res);
        if (res.code === 200 || res.code === 0) {
          // 数据在 res.data.list 中
          newsList.value = res.data?.list || [];
          total.value = res.data?.total || 0;
        }
      } catch (error) {
        console.error('获取新闻列表失败:', error);
      } finally {
        loading.value = false;
      }
    };
    // 格式化日期
    const formatDate = dateStr => {
      if (!dateStr) return '';
      // 处理格式：2026-01-30 00:00:00
      return dateStr.split(' ')[0];
    };
    // 跳转到详情页
    const goToDetail = id => {
      router.push(`/xwxq/${id}`);
    };
    // 分页切换
    const handlePageChange = page => {
      currentPage.value = page;
      getNewsList();
    };
    // 页面加载时获取数据
    onMounted(() => {
      const categoryId = route.query.categoryId;
      categoryTitle.value = categoryMap[categoryId] || '新闻列表';
      getNewsList();
    });
    return (_ctx, _cache) => {
      const _component_el_pagination = _resolveComponent("el-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(SectionTitle, {
        title: categoryTitle.value,
        showMore: false,
        class: "blue-title"
      }, null, 8, ["title"]), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, "加载中...")) : (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsList.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "news-item",
          key: item.id,
          onClick: $event => goToDetail(item.id)
        }, [_createElementVNode("div", _hoisted_7, [_cache[1] || (_cache[1] = _createElementVNode("span", {
          class: "dot"
        }, null, -1)), _createElementVNode("span", _hoisted_8, _toDisplayString(item.title), 1)]), _createElementVNode("div", _hoisted_9, _toDisplayString(formatDate(item.publishTime)), 1)], 8, _hoisted_6);
      }), 128))])), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_pagination, {
        background: "",
        layout: "total, prev, pager, next",
        total: total.value,
        "page-size": pageSize.value,
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => currentPage.value = $event),
        onCurrentChange: handlePageChange
      }, null, 8, ["total", "page-size", "current-page"])])])]), _createVNode(Footer)]);
    };
  }
});